import ownerRoutes from './routes'

/* @ngInject */
const ownerRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(ownerRoutes.index.path, {
      url: ownerRoutes.index.url,
      template: require('./templates/index.html'),
      controller: 'ownerCtrl',
      redirectTo: ownerRoutes.home.path,
    })
    .state(ownerRoutes.home.path, {
      url: ownerRoutes.home.url,
      template: require('./templates/home.html'),
    })
    .state(ownerRoutes.new.path, {
      url: ownerRoutes.new.url,
      template: require('./templates/new.html'),
    })
    .state(ownerRoutes.edit.path, {
      url: ownerRoutes.edit.url,
      template: require('./templates/edit.html'),
    })
    .state(ownerRoutes.details.path, {
      url: ownerRoutes.details.url,
      template: require('./templates/details.html'),
    })
}

export default ownerRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/owner/owner.routes.js